"use strict";
/**
 * Client-safe utility functions for prompt handling
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPlaceholderNames = extractPlaceholderNames;
/**
 * Extracts placeholder names from prompt messages.
 * This is a client-safe version that doesn't depend on server-side types.
 * @param messages Array of prompt messages
 * @returns Array of placeholder names
 */
function extractPlaceholderNames(messages) {
    return messages
        .filter((msg) => msg.type === "placeholder" && typeof msg.name === "string")
        .map((msg) => msg.name);
}
